/**
 * IMPORTANT
 *
 * Keep the values in this file sorted
 */
export const ZIndex = {
  FloatingSidebarButton: 100, // displays the side bar when
  CommunicationInputLabel: 1400, // label for the textarea with special triggers, e.g. @ $ #
  CommunicationInputLabelLower: 1300, // label for the textarea with special triggers lower than the modal
  CommunicationInputSuggestionsMenu: 1500, // menu for the textarea with special triggers, e.g. @ $ #
  ReactSelectMenu: 1600,
  OmniSearch: 2000,
}
